import Cookies from "js-cookie";
import { createActionType, createAsyncAction } from "./create-actions";

export const ADD_INFO = createActionType("ADD_INFO");
export const GET_INFOS = createActionType("GET_INFOS");
export const GET_INFO_BY_ID = createActionType("GET_INFO_BY_ID");
export const EDIT_INFO = createActionType("EDIT_INFO");
export const REMOVE_INFO = createActionType("REMOVE_INFO");

export const addInfo = (data: any) =>
  createAsyncAction(ADD_INFO, "/site_info/add_site_info", "post", data, {
    Authorization: `Bearer ${Cookies.get("token")}`,
  });

export const getInfo = () =>
  createAsyncAction(
    GET_INFOS,
    "/site_info/get_all_site_info",
    "get",
    undefined
  );

export const getInfoById = (id: any) =>
  createAsyncAction(
    GET_INFO_BY_ID,
    `/site_info/get_site_info_by_id/${id}`,
    "get",
    undefined
  );

export const editInfo = (id: any, data: any) =>
  createAsyncAction(EDIT_INFO, `/site_info/edit_site_info/${id}`, "put", data, {
    Authorization: `Bearer ${Cookies.get("token")}`,
  });

export const removeInfo = (id: any) =>
  createAsyncAction(
    REMOVE_INFO,
    `/site_info/remove_site_info/${id}`,
    "delete",
    undefined,
    {
      Authorization: `Bearer ${Cookies.get("token")}`,
    }
  );
